<template>
  <div class="verticals-menu__container">
    <ul class="verticals-menu">
      <template v-for="item in menuList" :key="item.id">
        <li class="verticals-menu__item">
          <a
            :href="item.link"
            :class="['verticals-menu__link', { 'verticals-menu__link_active': item.isActive }]"
            :target="item.target"
            @click="onMenuItemClick(item.id)"
          >
            {{ item.label }}
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@experience/i18n';
import { computed, onMounted } from 'vue';

import ru from '@/features/verticalsMenu/i18n/ru';
import { useAnalytics } from '@/shared/lib/analytics';

type MessageSchema = typeof ru;
const { t } = useI18n<{ message: MessageSchema }, 'ru'>({
  inheritLocale: true,
  messages: { ru },
});

const { trackEvent, trackEventImmediately } = useAnalytics();

const menuList = computed(() => {
  return [
    {
      id: 'experiences',
      label: t('experiences'),
      link: '/',
      isActive: true,
      target: '_self',
    },
    {
      id: 'tours',
      label: t('tours'),
      link: '/tours/',
      isActive: false,
      target: '_self',
    },
    {
      id: 'audioguides',
      label: t('audioguides'),
      // Внешние промо-лендинги Трипстера (не этот МФ). UTM-метки нужны маркетингу
      // для атрибуции переходов из шапки главной; менять только по согласованию.
      link: `https://promo.tripster.ru/audioguides?utm_campaign=site_header&utm_medium=main_web&utm_source=experience_tripster`,
      isActive: false,
      target: '_blank',
    },
    {
      id: 'transfers',
      label: t('transfers'),
      link: 'https://promo.tripster.ru/transfers',
      isActive: false,
      target: '_blank',
    },
  ];
});

const onMenuItemClick = (menuItem: string) => {
  /**
   * и отправляем согу
   */
  void trackEventImmediately('main:verticals-navigation.click', {
    menu_item: menuItem,
  });
};

onMounted(() => {
  void trackEvent('main:verticals-navigation.view');
});
</script>

<style lang="scss" scoped>
.verticals-menu {
  position: relative;
  box-sizing: border-box;
  display: flex;
  gap: var(--alias-space-12);
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;

  &__container {
    z-index: 3;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 84px 0 0;

    @include adaptivity.mobile {
      padding-top: 68px;
    }
  }

  &__item {
    display: inline-flex;
  }

  &__link {
    position: relative;
    box-sizing: border-box;
    display: inline-flex;
    padding: var(--alias-space-6) var(--alias-space-12);
    color: var(--alias-color-text-inverse);
    text-decoration: none;
    background-color: transparent;
    border-radius: var(--alias-space-8);

    &_active {
      color: var(--alias-color-text-inverse);
      background-color: var(--comp-button-secondary-color-background-inverted);
    }

    @include typography.base-400-400-medium;

    @include adaptivity.mobile {
      padding: var(--alias-space-6);

      @include typography.base-300-300-medium;
    }
  }

  @include adaptivity.mobile {
    gap: var(--alias-space-6);
  }
}
</style>
